"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chipOverrides = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _dist = require("@aaa-ncnu-ie/icons/dist");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var chipOverrides = {
  MuiChip: {
    defaultProps: {
      deleteIcon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
        component: _dist.FillRemove
      }),
      size: 'default'
    },
    variants: [{
      props: {
        variant: 'tag'
      },
      style: {}
    }],
    styleOverrides: {
      root: function root(_ref) {
        var _ref$ownerState$color = _ref.ownerState.color,
          color = _ref$ownerState$color === void 0 ? 'default' : _ref$ownerState$color,
          _ref$theme = _ref.theme,
          breakpoints = _ref$theme.breakpoints,
          opacity = _ref$theme.opacity,
          palette = _ref$theme.palette,
          shape = _ref$theme.shape,
          spacing = _ref$theme.spacing,
          typography = _ref$theme.typography;
        return _objectSpread(_objectSpread({}, typography.label), {}, _defineProperty({
          border: 'none',
          '&.MuiChip-outlined, &.MuiChip-tag': {
            '.MuiChip-label': {
              padding: "0 ".concat(spacing(1))
            }
          },
          '&.MuiChip-outlined': {
            height: 28,
            borderRadius: 24,
            boxShadow: palette.action.defaultOutline,
            '.MuiSvgIcon-root': {
              fontSize: 16
            },
            '.MuiChip-icon': {
              marginLeft: spacing(1),
              '& + .MuiChip-label': {
                paddingLeft: spacing(1.25)
              }
            },
            '&.MuiChip-deletable': {
              '.MuiChip-label': {
                paddingRight: spacing(1.25)
              }
            },
            '.MuiChip-deleteIcon': {
              color: (0, _styles.alpha)(palette.text.primary, opacity.chipDeleteIcon),
              marginRight: spacing(1),
              '&:hover': {
                color: (0, _styles.alpha)(palette.text.primary, opacity.chipDeleteIconHover)
              }
            }
          },
          '&.MuiChip-clickable': {
            willChange: 'transform',
            '&.Mui-focusVisible': {
              // TODO: focus state needs to be added to figma
              boxShadow: "".concat(palette.action.focusOutline, " ").concat(palette.common.black)
            },
            '&:hover': {
              boxShadow: "".concat(palette.action.nonSelectableHoverOutline, " ").concat(palette.common.black),
              background: palette.grey['50']
            },
            '&:active': {
              backgroundColor: (0, _styles.alpha)(palette.common.black, palette.action.activatedOpacity)
            }
          },
          '&.MuiChip-tag': _objectSpread({
            height: 24,
            borderRadius: shape.borderRadius
          }, color !== 'default' && {
            backgroundColor: palette[color].light,
            color: palette[color].contrastText
          })
        }, breakpoints.up('tablet'), _objectSpread(_objectSpread({}, typography.label), {}, {
          height: 28,
          '&&.MuiChip-outlined': {
            '.MuiChip-label': {
              padding: "0 ".concat(spacing(1.5))
            },
            '.MuiChip-icon': {
              marginLeft: spacing(1.5)
            },
            '.MuiChip-deleteIcon': {
              marginRight: spacing(1.5)
            }
          }
        })));
      }
    }
  }
};
exports.chipOverrides = chipOverrides;